import { Component, DetailEvent, Entity, registerComponent } from "aframe";


/*

"connection" component : a generic, meaningless, logical connection to another Entity

*/



export interface ConnectionDetail
{
	entity : Entity;
	connection : ConnectionComponent
};
export type ConnectionEvent = DetailEvent<ConnectionDetail>;

export interface ConnectionComponent extends Component
{
	data : Entity;
	isEntityConnection : boolean;
	getConnectedEntities() : Entity[];
};

registerComponent("connection", {
	schema : { type : "selector" },
	multiple : true,
	init(this : ConnectionComponent)
	{
		this.isEntityConnection = true;
	},
	getConnectedEntities(this : ConnectionComponent)
	{
		return this.data ? [ this.data ] : [];
	},
	update(this : ConnectionComponent, oldData : Entity)
	{
		if(this.data === oldData) return;

		// Don't emit on data : connection is generally unidirectional so connected entity doesn't know why it's connected to
		if(oldData)
		{
			//oldData.emit("disconnected-from-entity", { entity : this.el, connection : this } );
			this.el.emit("disconnected-from-entity", { entity : oldData, connection : this } );
		}
		if(this.data)
		{
			//this.data.emit("connected-to-entity", { entity : this.el, connection : this } );
			this.el.emit("connected-to-entity", { entity : this.data, connection : this } );
		}
	}
})